import { useFirestoreAllID } from '../../firebase/useFirestore'
import { Fragment } from 'react';

const UserNameMeta = ({userID}) => {

    const users = useFirestoreAllID('Users', userID ? userID : '123')

  return (
    <>
        {users && users.map( user => (
            <Fragment key={user.ID}>
                {user.ForName}
            </Fragment>
        ))}
    </>
  )
}

export default UserNameMeta